import React from 'react'

const AssignActivitiesContainer = (props) => <div id="post-secondary-nav">{props.children}</div>

export default AssignActivitiesContainer
